<template>
    <transition name="slide-fade" appear type="out-in">
        <span v-if="numeroAtual >= 0">  {{ numeroAtual }} </span>
    </transition>
</template>
<script>
export default {
    name: 'animated-number',
    data: ()=>({
        numeroAtual: -1,
    }),
    watch: {
        numero(newValue) {
            this.numeroAtual = newValue;
        }
    },
    props: {
        numero: {}
    }
}
</script>
<style lang="scss" scoped>
.slide-fade-enter-active {
  transition: all .8s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>